import { createContext, useContext } from 'react';
import { ProjectLabel, Organization, Project } from '../types';

export type ProjectSettingsQueryContextState = {
  project: Project;
  organization: Organization;
  timeZones: string[];
  labels: ProjectLabel[];
  refetchLabels: () => void;
  refetchProject: () => void;
  hasSmsChannel: boolean;
};

const defaultState = {
  project: {} as Project,
  organization: {} as Organization,
  timeZones: [],
  labels: [],
  refetchLabels: () => null,
  refetchProject: () => null,
  hasSmsChannel: false,
};

export const ProjectSettingsQueryContext =
  createContext<ProjectSettingsQueryContextState>(defaultState);

export const useProjectSettingsQueryContext = () => {
  const { project, organization, timeZones, labels, refetchLabels, refetchProject, hasSmsChannel } =
    useContext(ProjectSettingsQueryContext);

  return {
    project,
    organization,
    timeZones,
    labels,
    refetchLabels,
    refetchProject,
    hasSmsChannel,
  };
};
